import LiferayService from "./liferay";
const { REACT_APP_SCOPE_KEY, REACT_APP_PICKLIST_APP_CATEGROIE_ID } =
  process.env;

export const fetchAppsCategories = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.get(
        `o/headless-admin-list-type/v1.0/list-type-definitions/${REACT_APP_PICKLIST_APP_CATEGROIE_ID}`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const fetchApps = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.get(
        `o/c/apps/scopes/${REACT_APP_SCOPE_KEY}`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const fetchUserApps = (userId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.get(
        `o/headless-admin-user/v1.0/user-accounts/${userId}/userAppFavoris`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const fetchUserAccount = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.get(
        `o/headless-admin-user/v1.0/my-user-account`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const fetchUserRoleByEmail = (email) => {
    return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.getAdmin(
        `o/headless-admin-user/v1.0/user-accounts/by-email-address/${email}`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export const postUserAppFavoris = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.post(`/o/c/userappsfavorises`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const putUserAppFavoris = (userAppFavoriId, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await LiferayService.put(
        `/o/c/userappsfavorises/${userAppFavoriId}`,
        payload
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};
